import React from 'react'
import { SiHtml5 } from 'react-icons/si'
import { SiCss3, SiTailwindcss } from 'react-icons/si'
import { IoLogoJavascript } from 'react-icons/io'
import { IoLogoPython } from 'react-icons/io'
import { RiReactjsLine } from 'react-icons/ri'
import { TbBrandNextjs } from 'react-icons/tb'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faC } from '@fortawesome/free-solid-svg-icons'
import { FaBootstrap } from 'react-icons/fa'
import { TbBrandCpp } from 'react-icons/tb'
import { TbBrandTypescript } from 'react-icons/tb'
import { SiVite } from 'react-icons/si'

const Frontend = () => {
  return (
    <div className="skills__content">
      <h3 className="skills__title">Frontend Development</h3>
      <div className="skills__box">
        <div className="skills__group">
          <div className="skills__data">
            <FontAwesomeIcon icon={faC} />
            <div>
              <h3 className="skills__name">C</h3>
              <span className="skills__level">Coding Language</span>
            </div>
          </div>
          <div className="skills__data">
            <IoLogoPython />
            <div>
              <h3 className="skills__name">Python</h3>
              <span className="skills__level">Coding Language</span>
            </div>
          </div>
          <div className="skills__data">
            <SiHtml5 />
            <div>
              <h3 className="skills__name">HTML</h3>
              <span className="skills__level">Experience</span>
            </div>
          </div>
          <div className="skills__data">
            <SiCss3 />
            <div>
              <h3 className="skills__name">CSS</h3>
              <span className="skills__level">Experience</span>
            </div>
          </div>
          <div className="skills__data">
            <FaBootstrap />
            <div>
              <h3 className="skills__name">Bootstrap</h3>
              <span className="skills__level">Experience</span>
            </div>
          </div>
          <div className="skills__data">
            <SiTailwindcss />
            <div>
              <h3 className="skills__name">Tailwind</h3>
              <span className="skills__level">Experience</span>
            </div>
          </div>
        </div>
        <div className="skills__group">
          <div className="skills__data">
            <TbBrandCpp />
            <div>
              <h3 className="skills__name">C++</h3>
              <span className="skills__level">Coding Language</span>
            </div>
          </div>
          <div className="skills__data">
            <IoLogoJavascript />
            <div>
              <h3 className="skills__name">JavaScript</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
          <div className="skills__data">
            <TbBrandTypescript />
            <div>
              <h3 className="skills__name">Typescript</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
          <div className="skills__data">
            <RiReactjsLine />
            <div>
              <h3 className="skills__name">ReactJS</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
          <div className="skills__data">
            <TbBrandNextjs />
            <div>
              <h3 className="skills__name">NextJS</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
          <div className="skills__data">
            <SiVite />
            <div>
              <h3 className="skills__name">ViteJS</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Frontend
